import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { portalApi, setPortalToken } from '@/api/portal.api';
import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
import { showApiError } from '@/utils/apiError';

export function PortalVerifyPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get('token') ?? '');

  const verify = async (value: string) => {
    try {
      const res = await portalApi.verify(value);
      localStorage.setItem('portal_token', res.accessToken);
      setPortalToken(res.accessToken);
      navigate('/portal/dashboard');
    } catch (err) {
      showApiError(err, 'Invalid or expired link');
    }
  };

  useEffect(() => {
    const t = params.get('token');
    if (t) verify(t);
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6 dark:bg-slate-950">
      <div className="card max-w-md w-full p-8 space-y-4">
        <h1 className="text-lg font-semibold text-slate-900 dark:text-slate-100">Verify sign-in</h1>
        <Input label="Token" value={token} onChange={(e) => setToken(e.target.value)} />
        <Button onClick={() => verify(token)}>Continue</Button>
      </div>
    </div>
  );
}
